import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AnalyticsService } from '@common/services';
import { NewsService } from '@common/services/news.service';

@Component({
    selector: 'fina-news-list',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './news-list.component.html',
    styleUrls: ['news-list.component.scss'],
})
export class NewsListComponent implements OnInit {
    constructor(public newsService: NewsService, private analyticsService: AnalyticsService) {}

    ngOnInit() {
        this.newsService.loadRecentNews();
    }

    trackVerNovedades() {
        this.analyticsService.analyticsCapture('click_news_list_home');
    }
}
